<div #map tabindex="1" class="h-100"></div>
<div #popup class="popupContainer">
  <div #popupContent>
    <label #popupText></label>
    <label #additionalPopupText></label>
  </div>
</div>
